export const formatDecimal = (num) => {
  const [integer, decimal] = String(num).split('.');
  return decimal ? `${integer}.${decimal.slice(0, 2)}` : integer;
};